const includedItems = [
  {
    icon: "ri-file-shield-2-line",
    title: "出入境報關費",
    desc: "涵蓋香港出境及目的地入境的全程報關手續費，由我們團隊統一辦理，無需客人自行排隊申辦。",
    tag: "全程代辦",
  },
  {
    icon: "ri-government-line",
    title: "政府批文及旅行許可",
    desc: "包含所有政府、公安、海關、軍區等機構所需批文，以及特殊地區（西藏、新疆、邊境管制區）的旅行許可證。",
    tag: "特殊地區適用",
  },
  {
    icon: "ri-id-card-line",
    title: "臨時駕照及車牌",
    desc: "每台車輛包含 1 套臨時入境駕照及臨時號牌，讓港車合法在內地行駛。如需額外駕照，每個收費 HK$800。",
    tag: "每台車輛 1 套",
  },
  {
    icon: "ri-shield-check-line",
    title: "交強險及旅遊意外險",
    desc: "依法購置內地交強險（強制三責險），同時為每位參加者投保旅遊意外保險，保障人身安全。",
    tag: "合規必備",
  },
  {
    icon: "ri-user-voice-line",
    title: "全程中文導遊",
    desc: "專業持牌中文導遊全程同行（坐客人車輛內），負責溝通、協調，在特殊地區擔任嚮導及翻譯。",
    tag: "全程隨行",
  },
  {
    icon: "ri-bank-line",
    title: "海關保證金",
    desc: "車輛臨時入境所需的海關保證金由我們代為繳付及管理，行程結束後按規定退還，無需客人墊付大額費用。",
    tag: "我們代墊",
  },
];

const notIncluded = [
  { icon: "ri-hotel-line", text: "客人全程食宿費用" },
  { icon: "ri-ticket-2-line", text: "景點門票及參觀費" },
  { icon: "ri-shopping-bag-line", text: "個人購物及消費" },
  { icon: "ri-gas-station-line", text: "車輛油費及過路費" },
  { icon: "ri-road-map-line", text: "歐洲路線過路費（約 €200）" },
];

const notes = [
  {
    icon: "ri-add-circle-line",
    text: "如需額外臨時駕照，每個收費 HK$800",
  },
  {
    icon: "ri-earth-line",
    text: "歐洲路線另需「車輛國際通行證」及「綠卡保險」，費用另議",
  },
  {
    icon: "ri-information-line",
    text: "西藏旅遊許可證費用已包含於報價內",
  },
];

const PricingInfoSection = () => (
  <section id="pricing" className="py-24 bg-white">
    <div className="w-full px-6 lg:px-12">

      {/* Header */}
      <div className="text-center mb-14">
        <span className="text-orange-500 text-sm font-semibold tracking-wider uppercase mb-4 block">
          透明報價
        </span>
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          所有路線跨境服務一律包含
        </h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto">
          無論中國還是歐洲路線，以下跨境服務費用均已計入行程報價，無任何隱藏收費
        </p>
      </div>

      {/* Included Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
        {includedItems.map((item) => (
          <div
            key={item.title}
            className="bg-white rounded-2xl p-6 border border-stone-100 hover:border-orange-200 transition-all group"
          >
            <div className="flex items-start justify-between mb-4">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center group-hover:bg-green-100 transition-colors">
                <i className={`${item.icon} text-green-600 text-xl`}></i>
              </div>
              <span className="text-xs font-medium text-orange-600 bg-orange-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                {item.tag}
              </span>
            </div>
            <div className="flex items-center gap-2 mb-2">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-green-500 text-base"></i>
              </div>
              <h3 className="font-bold text-gray-900 text-base">{item.title}</h3>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed pl-7">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Bottom Row: Not Included + Notes + CTA */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* Not Included */}
        <div className="bg-white rounded-2xl p-6 border border-stone-100">
          <div className="flex items-center gap-2 mb-5">
            <div className="w-8 h-8 bg-red-50 rounded-full flex items-center justify-center">
              <i className="ri-close-line text-red-500 text-base"></i>
            </div>
            <h3 className="font-bold text-gray-900">報價不包含</h3>
          </div>
          <ul className="space-y-3">
            {notIncluded.map((item) => (
              <li key={item.text} className="flex items-center gap-3">
                <div className="w-7 h-7 flex items-center justify-center bg-stone-100 rounded-lg flex-shrink-0">
                  <i className={`${item.icon} text-stone-400 text-sm`}></i>
                </div>
                <span className="text-gray-600 text-sm">{item.text}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Notes */}
        <div className="bg-amber-50 rounded-2xl p-6 border border-amber-100">
          <div className="flex items-center gap-2 mb-5">
            <div className="w-8 h-8 bg-amber-100 rounded-full flex items-center justify-center">
              <i className="ri-error-warning-line text-amber-600 text-base"></i>
            </div>
            <h3 className="font-bold text-gray-900">重要備註</h3>
          </div>
          <ul className="space-y-4">
            {notes.map((note) => (
              <li key={note.text} className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className={`${note.icon} text-amber-500 text-base`}></i>
                </div>
                <span className="text-gray-700 text-sm leading-relaxed">{note.text}</span>
              </li>
            ))}
          </ul>
          <div className="mt-5 pt-4 border-t border-amber-200">
            <p className="text-amber-700 text-xs leading-relaxed">
              實際費用因路線、人數及車輛數目而異，請聯絡我們索取詳細報價。
            </p>
          </div>
        </div>

        {/* CTA Card */}
        <div className="bg-zinc-900 rounded-2xl p-6 flex flex-col justify-between">
          <div>
            <div className="w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center mb-5">
              <i className="ri-money-dollar-circle-line text-orange-400 text-2xl"></i>
            </div>
            <h3 className="text-white font-bold text-lg mb-3">索取詳細報價</h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6">
              告訴我們您的目的地、出發人數及車輛數目，我們在 24 小時內提供全包式詳細報價單，清晰列明每項費用。
            </p>
            <ul className="space-y-2 mb-6">
              {[
                "報價單清晰列出每項費用",
                "無任何隱藏收費",
                "24 小時內回覆",
              ].map((pt) => (
                <li key={pt} className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-orange-400 text-sm"></i>
                  </div>
                  <span className="text-zinc-300 text-sm">{pt}</span>
                </li>
              ))}
            </ul>
          </div>
          <button
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3.5 rounded-xl font-semibold text-sm transition-all flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
          >
            <span>立即索取報價</span>
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

      </div>

      {/* Bottom Guarantee Strip */}
      <div className="mt-8 bg-white rounded-2xl px-8 py-5 border border-stone-100 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
        {[
          { icon: "ri-shield-check-line", text: "全程合規，受保障" },
          { icon: "ri-file-text-line", text: "報價透明，無隱藏費用" },
          { icon: "ri-customer-service-2-line", text: "專人跟進，一手包辦" },
          { icon: "ri-time-line", text: "24 小時客服支援" },
        ].map((item) => (
          <div key={item.text} className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className={`${item.icon} text-orange-500 text-base`}></i>
            </div>
            <span className="text-gray-600 text-sm font-medium">{item.text}</span>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default PricingInfoSection;
